<template>
  <div
    class="card item"
    :class="{ 'item-disabled': !template.enabled }"
  >
    <div class="item-box">
      <div class="item-header">
        <base-toggle-arrow-button
          :section-visible="isOpen"
          @click.stop="toggleOpen"
          class="arrow-btn"
        />

        <BaseActionHeader
          class="header-content"
          spacing="none"
          title-tag="div"
        >
          <template #title>
            <div class="header-box">
              <div class="header-box-title">
                <h4 class="header-title">{{ template.name }}</h4>
                <span
                  v-if="template.kind"
                  class="kind-badge"
                  :class="`kind-badge--${template.kind}`"
                >
                  {{ formatTemplateKind(template.kind) }}
                </span>
              </div>

              <p class="header-desc" v-if="template.description">
                {{ template.description }}
              </p>
            </div>
          </template>

          <base-button @click.stop="$emit('duplicate', template)">
            Дублировать
          </base-button>

          <base-button @click.stop="$emit('render')">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                style="vertical-align: middle; margin-right: 5px"
              >
                <polyline points="6 9 6 2 18 2 18 9" />
                <path
                  d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
                />
                <rect x="6" y="14" width="12" height="8" />
              </svg>
            Напечатать
          </base-button>

          <base-toggle-switch
            :model-value="template.enabled"
            @update:model-value="$emit('toggle-status', template)"
            @click.stop
          />
        </BaseActionHeader>
      </div>

      <!-- Секция блоков -->
      <div v-if="isOpen" class="template-blocks-section">
        <TemplateBlocksList
          :template-id="template.id"
          :company-id="companyId"
          :read-only="true"
        />
      </div>

      <div
        class="section-bottom"
        v-if="template.created_at || template.updated_at"
      >
        <MetaTime
          :created-at="template.created_at"
          :updated-at="template.updated_at"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "pinia";
import { useTemplateStore } from "@/stores/templateStore";

import TemplateBlocksList from "./TemplateBlocksList.vue";
import MetaTime from "@/components/Meta/MetaTime.vue";

export default {
  name: "TemplateMainInfo",
  components: { TemplateBlocksList, MetaTime },
  props: {
    template: { type: Object, required: true },
    companyId: { type: [Number, String], required: true },
  },
  emits: ["toggle-status", "duplicate", "render"],
  data() {
    return { isOpen: false };
  },
  methods: {
    ...mapActions(useTemplateStore, ["formatTemplateKind"]),

    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style scoped>
.item {
  cursor: pointer;
}

.item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.item-disabled {
  background-color: rgba(186, 186, 186, 0.35);
}

.item-header {
  display: flex;
  align-items: center;
  gap: 20px;
}

.arrow-btn {
  flex-shrink: 0;
}

.header-box {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.header-box-title {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.header-title {
  margin: 0;
}

.header-desc {
  color: #666;
  margin: 0;
  max-width: 60%;
}

.kind-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 14px;
  line-height: 1.4;
  white-space: nowrap;
  letter-spacing: 0.2px;
}

.kind-badge--order_request {
  background-color: #dbeafe;
  color: #1d4ed8;
}

.kind-badge--order_invoice {
  background-color: #ede9fe;
  color: #6d28d9;
}

.kind-badge--expeditor_sheet {
  background-color: #e6f5ed;
  color: #2f855a;
}

.template-blocks-section {
  margin-top: var(--base-in-indent);
}

.section-bottom {
  margin-top: var(--base-in-indent);
}

@media (max-width: 768px) {
  .header-desc {
    max-width: 100%;
  }
}
</style>
